<script lang="ts">
  import Socials from './Socials.svelte'
  import PartnersScroller from './PartnersScroller.svelte'
  import Community from '../../components/Community.svelte'
</script>

<section class="mx-auto px-2 sm-desktop:space-y-12">
  <Socials />
  <PartnersScroller />
  <Community />
</section>
